import {validateCompanyId, validateNationalId} from './israeli-id';

export type BeneficiaryPersonIdError = 'invalid_national_id';
export type BeneficiaryCompanyIdError = 'invalid_company_id';

/**
 * Identifier check for a manually-added beneficiary who is a person: 5-9 digits, left-padded
 * to 9 before the checksum runs so a shortened id (a common shorthand) still validates. Foreign
 * passports are not accepted for beneficiaries.
 */
export function validateBeneficiaryPersonId(value: string): BeneficiaryPersonIdError | null {
  if (!/^\d{5,9}$/.test(value)) return 'invalid_national_id';
  return validateNationalId(value.padStart(9, '0')) === null ? null : 'invalid_national_id';
}

/**
 * Format-only identifier check for a manually-added beneficiary who is a company — reuses
 * `validateCompanyId`'s format/leading-digit rules but waives its checksum: a government/trust
 * company registration number here isn't guaranteed to follow the private-company checksum scheme.
 */
export function validateBeneficiaryCompanyId(value: string): BeneficiaryCompanyIdError | null {
  const error = validateCompanyId(value);
  return error === null || error === 'invalid_checksum' ? null : 'invalid_company_id';
}
